import request from '@/utils/request'

// 获取路由列表
export function getRouters() {
  return request({
    url: '/customization/router/v1/query/list',
    method: 'get'
  })
}
